<template>
  <v-card elevation="0" outlined class="d-flex flex-column h-100" min-height="350">
    <v-card-title class="pb-0">
      <v-icon color="secondary" large class="mr-2">ballot</v-icon>
      <div class="d-flex flex-column">
        <span class="primary--text monospace-font body-1 font-weight-medium">{{ $t("app.uploadedGames") }}</span>
        <span class="subheader-font body-2">{{ $t("uploadedGames.subtitle") }}</span>
      </div>
    </v-card-title>
    <v-card-text class="d-flex flex-column pb-1 overflow-auto flex-grow-1">
      <v-data-table dense disable-items-per-page 
        :headers="headers" 
        :items="games"
        :footer-props="{ itemsPerPageOptions: $vuetify.breakpoint.smAndDown ? [1] : [5]}"
        :loading="loading"
      >
        <!--Link-->
        <template v-slot:item.link="{ item }">
          <v-btn color="secondary" class="mr-2 px-1 elevation-0" target="_blank" :to="`/video-highlights/game/${item.gameId}`" x-small>
            <v-icon small>ondemand_video</v-icon>
          </v-btn>
        </template>
        <!--Name-->
        <template v-slot:item.name="{ item }">
          <router-link :to="`/game/${item.gameId}`" target="_blank" class="d-flex flex-column">
            <div class="d-flex justify-space-between mt-1">
              <span class="body-1 text-ellipsis w-85">{{item.homeTeamName}}</span>
              <span class="body-1">{{item.homeTeamResult}}</span>
            </div>
            <div class="d-flex justify-space-between mb-1">
              <span class="body-1 text-ellipsis w-85">{{item.awayTeamName}}</span>
              <span class="body-1">{{item.awayTeamResult}}</span>
            </div>
          </router-link>
        </template>
        <!--League-->
        <template v-slot:item.leagueName="{ item }">
          <span class="body-1">{{item.leagueName}}</span>
        </template>
        <!--CC-->
        <template v-slot:header.collectionCompleted="{ item }">
          <v-tooltip top color="lightSecondary lighten-4" max-width="300">
            <template v-slot:activator="{ on }">
              <span v-on="on">CC</span>
            </template>
            <span class="black--text body-1">{{ $t(`uploadedGames.collectionCompleted`) }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.collectionCompleted="{ item }">
          <v-icon color="green" v-if="item.collectionCompleted" small>check_circle</v-icon>
          <v-icon color="blue" v-else small>schedule</v-icon>
        </template>
        <!--SLA-->
        <template v-slot:header.sla="{ item }">
          <v-tooltip top color="lightSecondary lighten-4" max-width="300">
            <template v-slot:activator="{ on }">
              <span v-on="on">SLA</span>
            </template>
            <span class="black--text body-1">{{ $t(`uploadedGames.sla`) }}</span>
          </v-tooltip>
        </template>
        <!--SLA-->
        <template v-slot:item.sla="{ item }">
          <span class="monospace-font">{{item.sla}}</span>
        </template>
        <!--Time requested-->
        <template v-slot:item.tsTime="{ item }">
          <span class="body-1">{{item.ts}}</span>
        </template>
      </v-data-table>
      <v-divider class="mt-1"></v-divider>
    </v-card-text>
    <v-card-actions class="justify-end flex-shrink-0">
      <v-btn color="secondary" class="elevation-0 monospace-font white--text px-5" rounded small :to="`/uploaded-games`">{{$t('uploadedGames.goToUploadedGames')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

import ResizeObserver from 'resize-observer-polyfill';
import * as _ from 'lodash';
import moment from 'moment';
import GameService from '../../../services/game/game.service';

export default {
  name: "UploadedGamesWidget",
  data() {
    return {
      loading: false,
      observer: null,
      games: [],
      headers: [
        {
          text: "Link",
          value: "link",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("playerDetail.name"),
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: this.$t("playerScout.league"),
          value: "leagueName",
          align: "start",
          sortable: false,
        },
        {
          text: "CC",
          value: "collectionCompleted",
          align: "center",
          sortable: false,
        },
        {
          text: "SLA",
          value: "sla",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t('uploadedGames.timeRequested'),
          align: "start",
          value: "tsTime",
          sortable: false,
        },
      ],
    }
  },
  async created() {
    await this.loadViewData();
  },
  mounted() {
    this.observer = new ResizeObserver(this.onResize).observe(this.$el);
  },
  methods: {
    async loadViewData(){
      this.loading = true;
      const uploadedGamesData = await GameService.getUploadedGames(0, 20);
      this.games = _.chain(uploadedGamesData.data.table.items).map(g => {
        g.name = `${g.homeTeamName} ${g.homeTeamResult} - ${g.awayTeamResult} ${g.awayTeamName}`;
        g.tsTime = moment(g.ts,'DD/MM/YYYY HH:mm').unix();
        g.collectionCompleted = g.collectionCompleted == null ? false : g.collectionCompleted;
        return g;
      }).filter(g => g.ts !== null).orderBy(['tsTime','leagueName','matchDateTime','homeTeamName'],['desc','asc','desc','asc']).value();
      this.loading = false;
    },
    onResize () {
      this.$emit('heightChange', this.$el.clientHeight)
    },
  },
  destroyed () {
    delete this.observer;
  }
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/widgets/UploadedGamesWidget.vue